import PropTypes from 'prop-types'

import { idPropType } from '../common/id-prop-type.js'
import { energyConsumptionPreferencePropType } from '../vehicle/energy-consumption-preference-prop-type'
import { chargingStationConnectorTypePropType } from './charging-station-connector-type-prop-type'

/**
 * @typedef {Object} ElectricVehicleSettings
 *
 * @property {string} objectId - The object id unique identifier
 * @property {number} [averageEnergyConsumption] - The electric vehicle average energy consumption
 * @property {number} [batteryCapacity] - The electric vehicle battery capacity [in kWh]
 * @property {Array} [connectorTypes] - List of charging station connector types
 * @property {number} [customVehicleEnergyConsumption] - The electric vehicle custom energy consumption
 * @property {string} [energyConsumptionPreference] - The electric vehicle energy consumption preference
 */
export const electricVehicleSettingsPropType = PropTypes.shape({
    averageEnergyConsumption: PropTypes.number,
    batteryCapacity: PropTypes.number,
    connectorTypes: PropTypes.arrayOf(chargingStationConnectorTypePropType),
    customVehicleEnergyConsumption: PropTypes.number,
    energyConsumptionPreference: energyConsumptionPreferencePropType,
    objectId: idPropType.isRequired
})
